import React from 'react';

import Box from '@mui/material/Box';

import { SelectorType } from '../../../../types/SelectorType';

import SelectorSegment from './SelectorSegment';

import './Selector.scss';

type Props = {
  type: 'admin' | 'florence';
  value: SelectorType;
  handleChange: (state: SelectorType) => void;
};

const Selector: React.FC<Props> = ({ type, value, handleChange }) => {
  const setSegment = (type: SelectorType) => {
    handleChange(type);
  };

  return (
    <Box className='user-codes-selector-container' sx={{ mb: '15px' }}>
      <SelectorSegment
        type='OPNotes'
        bottomState={value}
        label='OP Notes'
        setSegment={setSegment}
      />
      <SelectorSegment
        type='ClinicNotes'
        bottomState={value}
        label='Clinic Notes'
        setSegment={setSegment}
      />
      <SelectorSegment
        type='Codes'
        bottomState={value}
        label='Favorite Codes'
        setSegment={setSegment}
      />

      {type === 'admin' && (
        <SelectorSegment
          type='Flagged'
          bottomState={value}
          label='Flagged Codes'
          setSegment={setSegment}
        />
      )}
    </Box>
  );
};

export default Selector;
